import { merge } from '../utils/utility';

const borderClass = 'border border-primary-std rounded-md';
const focusClass = 'focus:ring-primary-500 focus:border-primary-500';
const textClass = 'sm:text-sm bg-primary-std text-primary-std';
const whiteTextClass = 'sm:text-sm text-white';

const backgroundColorClass = (secondary?: boolean) => (secondary ? 'bg-secondary-800' : 'bg-primary-800');

export const baseInputClass = merge(borderClass, focusClass, textClass);
export const baseCardClass = merge(borderClass, textClass);
export const colorButtonClass = (secondary?: boolean) => merge(focusClass, whiteTextClass, backgroundColorClass(secondary));
